import React from 'react'
import SmartAutocomplete from './SmartAutocomplete'

const InstrumentAutocomplete = (props: {
	instruments: string[],
	instrument: string,
	onInstrumentChange: (instrument: string) => void,
	outlined?: boolean,
}) => {

	const {
		instruments,
		instrument,
		onInstrumentChange,
		outlined,
	} = props

	return (
		<SmartAutocomplete
			keyName='i'
			label='Instrument'
			value={instrument}
			options={instruments}
			getOptionLabel={(option: any) => option}
			style={{ width: outlined ? 300 : 185, margin: 16 }}
			onChange={(e: any, instrument: any) => instrument && onInstrumentChange(instrument)}
		/>
	)
}

export default InstrumentAutocomplete
